package org.hs_soft.runmynesto.domain.model.home.closing_reports

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class SalesGroupTableHeadersEnum(
    val title: String,
    val key: String,
    val isNumberic: Boolean = false
) {
    SALES_GROUP(
        title = LanguageManager.getCurrentStrings().salesGroups,
        key = "salesGroup",
        isNumberic = false
    ),
    NUMBER(
        title = LanguageManager.getCurrentStrings().number,
        key = "amount",
        isNumberic = true
    ),
    DISCOUNT(
        title = LanguageManager.getCurrentStrings().discount,
        key = "discount",
        isNumberic = true
    ),
    REDUCTION(
        title = LanguageManager.getCurrentStrings().reduction,
        key = "reduction",
        isNumberic = true
    ),
    FREE_VAT(
        title = LanguageManager.getCurrentStrings().freeVat,
        key = "mWStFree",
        isNumberic = true
    ),
    NORMAL_VAT(
        title = LanguageManager.getCurrentStrings().normalVat,
        key = "mWStNormal",
        isNumberic = true
    ),
    REDUCED_VAT(
        title = LanguageManager.getCurrentStrings().reducedVat,
        key = "mWStReduced",
        isNumberic = true
    ),
    SPECIAL_VAT(
        title = LanguageManager.getCurrentStrings().specialVat,
        key = "mWStSpecial",
        isNumberic = true
    ),
    SALES_VOLUME(
        title = LanguageManager.getCurrentStrings().salesVolume,
        key = "total",
        isNumberic = true
    )
}